import { ReactElement, useState, useCallback } from 'react';

import { useTheme, Theme, Box, Collapse } from '@mui/material';

import { Arrow as ArrowPlugin } from '@egjs/flicking-plugins';
import Flicking, { ViewportSlot } from '@egjs/react-flicking';
import { useEventListener } from 'usehooks-ts';
import '@egjs/react-flicking/dist/flicking.css';
import '@egjs/react-flicking/dist/flicking-inline.css';

import Arrow from './components/Arrow';
import Navigation from './components/Navigation';
import Panel from './components/Panel';
import panels from './data';

const plugins = [new ArrowPlugin()];

export default function Header(): ReactElement {
  const theme = useTheme();

  const [scrollHeight, setScrollHeight] = useState<number>(0);

  const handleScroll = useCallback(() => {
    setScrollHeight(document.scrollingElement?.scrollTop || 0);
  }, []);

  useEventListener('scroll', handleScroll);

  return (
    <Box
      sx={{
        position: 'relative',

        transition: (theme: Theme) =>
          `${theme.transitions?.duration?.complex}ms ${theme.transitions?.easing?.easeInOut}`
      }}>
      <Collapse
        easing={theme.transitions.easing.easeInOut}
        in={scrollHeight > 180}
        timeout={{
          enter: theme.transitions.duration.standard,
          exit: theme.transitions.duration.short
        }}
        sx={{ width: '100%', position: 'fixed', top: 0, zIndex: 1000 }}>
        <Navigation invert />
      </Collapse>

      <Navigation />

      <Flicking
        align='center'
        duration={theme.transitions.duration.complex}
        circular={true}
        plugins={plugins}
        onHoldStart={(event) => event.stop()}>
        {panels.map((panel, index) => (
          <Box
            key={index}
            className='panel'
            sx={{
              width: '100%',
              height: '100vh',

              position: 'relative'
            }}>
            <Panel {...panel} />
          </Box>
        ))}

        <ViewportSlot>
          {/* Left Arrow Button */}
          <Arrow direction='prev' />

          {/* Right Arrow Button */}
          <Arrow direction='next' />
        </ViewportSlot>
      </Flicking>
    </Box>
  );
}
